module.exports = __webpack_public_path__ + "img/BZ.c08d4857.png";